module.exports = __webpack_public_path__ + "img/ltp.708d780f.svg";